import { api } from "../client";
import {
  DiscountExtraFields,
  DiscountFields,
  PartialDiscountExtraFields,
  PartialDiscountFields,
} from "../schema/Discount";
import { Config, ConfigMutate } from "../types";

type ApiRequestConfig = Config<DiscountFields, DiscountExtraFields>;
type ApiRequestConfigMutate = ConfigMutate<
  PartialDiscountFields,
  PartialDiscountExtraFields
>;

export const getDiscounts = async (config?: ApiRequestConfig) => {
  return api.get<DiscountFields, DiscountExtraFields>("discounts", config);
};
export const getDiscount = (id: number, config?: ApiRequestConfig) => {
  return api.get<DiscountFields, DiscountExtraFields>(
    `discounts/${id}`,
    config
  );
};

export const createDiscount = (config: ApiRequestConfigMutate) => {
  return api.create<PartialDiscountFields, PartialDiscountExtraFields>(
    "discounts",
    config
  );
};
export const updateDiscount = (id: number, config?: ApiRequestConfigMutate) => {
  return api.update<PartialDiscountFields, PartialDiscountExtraFields>(
    `discounts/${id}`,
    config
  );
};
export const deleteDiscount = (id: number) => {
  return api.remove<DiscountFields, DiscountExtraFields>(`discounts/${id}`);
};
